const InterestType = {
  FIX_INTEREST: 'Fix kamatozású',
  FLOATING_INTEREST: 'Változó kamatozású',
  NO_INTEREST: 'Kamatmentes'
}
export default InterestType
